var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 
    'overlay-custom': _vm.getOverlay === 'visible', 
    'overlay-not-init': _vm.getOverlay === '', 
		'closed-overlay': _vm.getOverlay === 'notVisible' },attrs:{"id":"overlay"},on:{"click":_vm.touched}})
}
var staticRenderFns = []

export { render, staticRenderFns }